import React, { useState, useEffect } from 'react';
import Marquee from 'react-fast-marquee';
import { cryptoApi } from '../utils/api';
import CurrencyIcon from './CurrencyIcon';

const TICKER_SYMBOLS = ['BTC', 'ETH', 'USDT', 'BNB', 'SOL', 'XRP', 'USDC', 'ADA', 'DOGE', 'LTC', 'DOT', 'AVAX'];

const CryptoTicker = () => {
  const [prices, setPrices] = useState({});

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await cryptoApi.getRates();
        setPrices(response.data);
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
    };
    fetchPrices();
    const interval = setInterval(fetchPrices, 15000);

    let ws;
    try {
      const streams = ['btcusdt','ethusdt','bnbusdt','solusdt','xrpusdt','adausdt','dogeusdt','ltcusdt','dotusdt'].map(s => `${s}@ticker`).join('/');
      ws = new WebSocket(`wss://data-stream.binance.vision/stream?streams=${streams}`);
      ws.onmessage = (evt) => {
        try {
          const { data } = JSON.parse(evt.data);
          if (!data?.s) return;
          const sym = data.s.replace('USDT', '');
          setPrices(prev => ({ ...prev, [sym]: { ...(prev[sym] || {}), usd: parseFloat(data.c), price: parseFloat(data.c), change_24h: parseFloat(data.P) } }));
        } catch {}
      };
    } catch {}
    return () => { clearInterval(interval); try { ws && ws.close(); } catch {} };
  }, []);

  const formatPrice = (price) => {
    if (!price) return '---';
    if (price >= 1000) return price.toLocaleString('en-US', { maximumFractionDigits: 0 });
    if (price >= 1) return price.toLocaleString('en-US', { maximumFractionDigits: 2 });
    return price.toLocaleString('en-US', { maximumFractionDigits: 6 });
  };

  return (
    <div className="bg-[#0A0B0D]" data-testid="crypto-ticker">
      <Marquee speed={35} gradient={true} gradientColor="#0A0B0D" gradientWidth={60} pauseOnHover={true} className="py-2.5">
        {TICKER_SYMBOLS.map((symbol) => {
          const priceData = prices[symbol] || {};
          const price = priceData.price || priceData.usd || 0;
          const change = priceData.change_24h || 0;
          const isPositive = change >= 0;

          return (
            <div key={symbol} className="flex items-center space-x-2 px-6 whitespace-nowrap">
              <CurrencyIcon symbol={symbol} size={16} />
              <span className="font-mono-data text-xs font-medium text-white/50">{symbol}</span>
              <span className="font-mono-data text-xs text-white">${formatPrice(price)}</span>
              {change !== 0 && (
                <span className={`font-mono-data text-xs font-medium ${isPositive ? 'text-emerald-400' : 'text-rose-400'}`}>
                  {isPositive ? '+' : ''}{change.toFixed(2)}%
                </span>
              )}
              <span className="text-white/10 ml-2">|</span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};

export default CryptoTicker;
